import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../../../../environments/environmet';
import {
  ApiResponse,
  CompanyItem,
  CompanyRegisterRequest,
  CreateCompanyRequest,
  PagedCompaniesResponse,
  UpdateCompanyRequest,
  AdjustWalletRequest,
} from '../models/company.models';
import {
  CompanyPricingResponse,
  UpdateCompanyPricingRequest,
} from '../models/company-pricing.models';

@Injectable({
  providedIn: 'root',
})
export class CompaniesApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/companies`;

  getCompanies(
    pageNumber: number = 1,
    pageSize: number = 20,
    search?: string,
    isActive?: boolean,
  ): Observable<ApiResponse<PagedCompaniesResponse>> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());

    if (search) {
      params = params.set('search', search);
    }

    if (isActive !== undefined && isActive !== null) {
      params = params.set('isActive', isActive.toString());
    }

    return this.http.get<ApiResponse<PagedCompaniesResponse>>(this.baseUrl, { params });
  }

  getCompany(companyId: number): Observable<ApiResponse<CompanyItem>> {
    return this.http.get<ApiResponse<CompanyItem>>(`${this.baseUrl}/${companyId}`);
  }

  createCompany(payload: CreateCompanyRequest): Observable<ApiResponse<CompanyItem>> {
    return this.http.post<ApiResponse<CompanyItem>>(this.baseUrl, payload);
  }

  updateCompany(companyId: number, payload: UpdateCompanyRequest): Observable<ApiResponse<CompanyItem>> {
    return this.http.put<ApiResponse<CompanyItem>>(`${this.baseUrl}/${companyId}`, payload);
  }

  deleteCompany(companyId: number): Observable<ApiResponse<string>> {
    return this.http.delete<ApiResponse<string>>(`${this.baseUrl}/${companyId}`);
  }

  getCompanyPricing(companyId: number): Observable<ApiResponse<CompanyPricingResponse>> {
    return this.http.get<ApiResponse<CompanyPricingResponse>>(`${this.baseUrl}/${companyId}/pricing`);
  }

  updateCompanyPricing(companyId: number, payload: UpdateCompanyPricingRequest): Observable<ApiResponse<string>> {
    return this.http.post<ApiResponse<string>>(`${this.baseUrl}/${companyId}/pricing`, payload);
  }

  registerCompany(payload: CompanyRegisterRequest): Observable<ApiResponse<CompanyItem>> {
    return this.http.post<ApiResponse<CompanyItem>>(`${this.baseUrl}/register`, payload);
  }

  adjustCompanyWallet(companyId: number, payload: AdjustWalletRequest): Observable<ApiResponse<string>> {
    return this.http.post<ApiResponse<string>>(`${this.baseUrl}/${companyId}/wallet/adjust`, payload);
  }
}